export default "__VITE_ASSET__BIAkS7iH__"